import { findAll, find } from '../utils/dom'

const editor = () => {

	function animadetails(editor) {
		editor.querySelectorAll('.editor-dropdown').forEach(drop => {
			const summary = drop.querySelector('.summary')
			const content = drop.querySelector('.editor-content')

			// Inicializa altura e opacidade de acordo com a classe 'open'
			if (drop.classList.contains('open')) {
				content.style.maxHeight = content.scrollHeight + 'px'
				content.style.opacity = 1
			} else {
				content.style.maxHeight = '0'
				content.style.opacity = 0
			}

			content.style.overflow = 'hidden'
			content.style.transition = 'max-height 0.3s ease, opacity 0.3s ease'

			summary.addEventListener('click', () => {
				const isOpen = drop.classList.contains('open')
				if (isOpen) {
					content.style.maxHeight = '0'
					content.style.opacity = 0
					drop.classList.remove('open')
				} else {
					content.style.maxHeight = content.scrollHeight + 'px'
					content.style.opacity = 1
					drop.classList.add('open')
				}
			})
		})
	}
  function makerEditorTagsOLD(editor) {
    if (editor.innerText && editor.innerText.trim()) {
      let Texto
      try {
        Texto = JSON.parse(editor.innerText)
      } catch (error) {
        console.error('Erro ao fazer parse do conteúdo do editor:', error)
        return
      }

      let ResultText = ''
      let TotalTag = Texto.blocks.length

      for (let i = 0; i < TotalTag; i++) {
        const Tipo = Texto.blocks[i].type
        switch (Tipo) {
          case 'paragraph':
            ResultText += `<p>${Texto.blocks[i].data.text}</p>`
            break

          case 'Header':
            const Level = Texto.blocks[i].data.level
            ResultText += `<h${Level}>${Texto.blocks[i].data.text}</h${Level}>`
            break

          case 'List':
            ResultText += `<ul class='${Texto.blocks[i]?.data?.style}'>`
            const Itens = Texto.blocks[i].data.items
            for (let k of Itens) {
              ResultText += `<li>${k}</li>`
            }
            ResultText += `</ul>`
            break

          case 'Image':
            const { file, caption } = Texto.blocks[i].data
            const alt = caption || ''
            const isVideoLink = alt.includes('youtube.com') || alt.includes('youtu.be') || alt.includes('vimeo.com')

            if (isVideoLink) {
              ResultText += `
                <div class="video-wrapper" data-video="${alt}" data-thumb="${file.url}">
                  <img src="${file.url}" alt="${alt}" class="video-thumb" style="cursor:pointer;" />
                </div>`
            } else {
              ResultText += `<img src="${file.url}" alt="${alt}" />`
            }
            break

          case 'Embed':
            ResultText += `
              <div class="wrapper-embed">
                <div class="embed ${Texto.blocks[i].data.service}">
                  <iframe width="${Texto.blocks[i].data.width}" height="${Texto.blocks[i].data.height}" src="${Texto.blocks[i].data.embed}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
              </div>`
            break
        }
      }

      editor.innerHTML = ResultText
    }
  }

	function safeJSONParse(str) {
		try {
			return JSON.parse(str)
		} catch {
			return null // ou {} se quiser garantir objeto
		}
	}

	function makerEditorTags(editor) {
  if (!(editor.innerText && editor.innerText.trim())) return

  let Texto
  try {
    Texto = safeJSONParse(editor.innerText)
  } catch (error) {
    console.error('Erro ao fazer parse do conteúdo do editor:', error)
    return
  }

	if (!Texto || !Array.isArray(Texto.blocks)) return

  const stripTags = (s = '') => s.replace(/<[^>]*>/g, '')
  const escapeHTML = (s = '') =>
    s.replace(/&/g, '&amp;')
     .replace(/</g, '&lt;')
     .replace(/>/g, '&gt;')
     .replace(/"/g, '&quot;')
     .replace(/'/g, '&#39;')

  const renderBlock = (b) => {
    const type = (b.type || '').toLowerCase()
    switch (type) {
      case 'paragraph':
        return `<p>${b.data?.text ?? ''}</p>`

      case 'header':
        const level = b.data?.level ?? 2
        return `<h${level}>${b.data?.text ?? ''}</h${level}>`

      case 'list':
        {
          const style = b.data?.style ? ` class="${b.data.style}"` : ''
          const items = Array.isArray(b.data?.items) ? b.data.items : []
          let html = `<ul${style}>`
          for (const k of items) html += `<li>${k}</li>`
          html += `</ul>`
          return html
        }

      case 'image':
        {
          const file = b.data?.file ?? {}
          const caption = b.data?.caption ?? ''
          const alt = caption || ''
          const url = file.url || ''
          const isVideoLink =
            alt.includes('youtube.com') ||
            alt.includes('youtu.be') ||
            alt.includes('vimeo.com')

          if (isVideoLink) {
            return `
              <div class="video-wrapper" data-video="${alt}" data-thumb="${url}">
                <img src="${url}" alt="${alt}" class="video-thumb" style="cursor:pointer;" />
              </div>`
          }
          return `<img src="${url}" alt="${alt}" />`
        }

      case 'embed':
        return `
          <div class="wrapper-embed">
            <div class="embed ${b.data?.service ?? ''}">
              <iframe width="${b.data?.width ?? ''}" height="${b.data?.height ?? ''}" src="${b.data?.embed ?? ''}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
          </div>`

      default:
        return '' // tipos desconhecidos: ignora
    }
  }

  let ResultText = ''
  let dropdownAberto = false

  for (const block of Texto.blocks) {
    // Detecta marcadores apenas em parágrafos
    if ((block.type || '').toLowerCase() === 'paragraph') {
      const raw = block.data?.text ?? ''
      const clean = stripTags(raw).trim()

      // [dropdown], [dropdown:Título], [dropdown:Título | open], [dropdown|open]
      const m = clean.match(/^\[dropdown(?::\s*([^\]\|]+?)\s*)?(?:\|\s*(open)\s*)?\]$/i)
      if (m) {
				

				const inglesEl = editor.closest('.ingles')
				const isInglesVisible = inglesEl && window.getComputedStyle(inglesEl).display !== 'none'
			  const defaultTitulo = isInglesVisible ? 'About the work' : 'Sobre o trabalho'

        const titulo = (m[1] ? m[1].trim() : defaultTitulo)
       
				const isOpen = m[2] ? m[2].trim().toLowerCase() === 'open' : false

        ResultText += `<div  class="editor-dropdown ${isOpen ? ' open' : ''}"${isOpen ? ' open' : ''}>
                <div class="summary">${escapeHTML(titulo)}</div>
                <div class="editor-content">`
        dropdownAberto = true
        continue // não renderiza o parágrafo do marcador
      }

      // [enddropdown]
      if (/^\[enddropdown\]$/i.test(clean)) {
        if (dropdownAberto) {
          ResultText += `</div></div>`
          dropdownAberto = false
        }
        continue // não renderiza o parágrafo do marcador
      }
    }

    // Render normal, dentro ou fora do dropdown
    ResultText += renderBlock(block)
  }

  // Fecha caso alguém esqueça o [enddropdown]
  if (dropdownAberto) {
    ResultText += `</div></div>`
  }

  editor.innerHTML = ResultText

	animadetails(editor)
	}

  const EditorTags = findAll('[js-editor-tags]')

  if (EditorTags) {
    EditorTags.forEach((editor) => {
      makerEditorTags(editor)
    })
  }

	let ytPlayers = {}; // Guarda instâncias dos players YouTube

document.addEventListener('click', function (e) {
  const target = e.target;

  if (target.classList.contains('video-thumb')) {
    const wrapper = target.closest('.video-wrapper');
    const videoUrl = wrapper.dataset.video;
    const thumbUrl = wrapper.dataset.thumb;

    let embedUrl = '';
    let videoId = '';

    // Detecta se é YouTube
    if (videoUrl.includes('youtube.com/watch')) {
      videoId = new URL(videoUrl).searchParams.get('v');
      embedUrl = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1`;
    } 
    // Detecta se é Vimeo
    else if (videoUrl.includes('vimeo.com')) {
      const vimeoId = videoUrl.split('/').pop();
      embedUrl = `https://player.vimeo.com/video/${vimeoId}?autoplay=1`;
    }

    wrapper.innerHTML = `
      <iframe id="player-${videoId}" src="${embedUrl}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen style="width:100%; aspect-ratio:16/9;"></iframe>
    `;

    // Vimeo
    if (embedUrl.includes('vimeo.com')) {
      const iframe = wrapper.querySelector('iframe');
      const vimeoPlayer = new Vimeo.Player(iframe);
      vimeoPlayer.on('ended', function () {
        wrapper.innerHTML = `<img src="${thumbUrl}" alt="${videoUrl}" class="video-thumb" style="cursor:pointer;" />`;
      });
    }

    // YouTube
    if (embedUrl.includes('youtube.com')) {
      const playerId = `player-${videoId}`;
      ytPlayers[playerId] = new YT.Player(playerId, {
        events: {
          'onStateChange': function (event) {
            if (event.data === YT.PlayerState.ENDED) {
              wrapper.innerHTML = `<img src="${thumbUrl}" alt="${videoUrl}" class="video-thumb" style="cursor:pointer;" />`;
            }
          }
        }
      });
    }
  }
});
	

  
}

export default editor
